module.exports = __webpack_public_path__ + "img/stock1.8d46095f.png";